export const filter = (obj, filterfn) =>
	Object.entries(obj).reduce(
		(filtered, [key, value]) =>
			filterfn(key, value) ? {...filtered, [key]: value} : filtered,
		{}
	)

export const filterPropName = (obj, propNames) =>
	filter(obj, key => propNames.includes(key))



// WEBPACK FOOTER //
// ./src/helper/object.js